import React, { useEffect, useState } from 'react';
import { ShoppingCart, Loader2, CheckCircle2, Minus, Plus } from 'lucide-react';
import { Button } from './ui/button';
import { useT } from '../services/i18n';

// Sticky bottom bar on phones: price + qty + add to cart, shown while the main button is off-screen
const MobileBuyBar = ({ anchorId, price, quantity, step, maxQty, onQty, onAdd, adding, added, disabled }) => {
  const { t } = useT();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = document.getElementById(anchorId);
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver(([e]) => setShow(!e.isIntersecting), { threshold: 0 });
    io.observe(el);
    return () => io.disconnect();
  }, [anchorId]);
  useEffect(() => {
    document.body.classList.toggle('has-buy-bar', show);
    return () => document.body.classList.remove('has-buy-bar');
  }, [show]);
  return (
    <div aria-hidden={!show} data-testid="mobile-buy-bar" data-visible={show ? 'true' : 'false'}
      className={`md:hidden fixed inset-x-0 bottom-0 z-[60] bg-white/95 backdrop-blur border-t border-gray-200 shadow-[0_-6px_20px_rgba(0,0,0,0.08)] px-3 pt-2 transition-transform duration-300 ${show ? 'translate-y-0' : 'translate-y-full pointer-events-none'}`}
      style={{ paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))' }}>
      <div className="flex items-center gap-2">
        <div className="min-w-0 flex-1">
          <p className="text-lg font-bold text-gray-900 leading-tight" data-testid="mobile-buy-bar-price">{price.toFixed(2)} €</p>
          <p className="text-[10px] text-gray-500 truncate">{t('product.ttcExclShipping')}</p>
        </div>
        <div className="flex items-center border rounded-lg bg-white">
          <button type="button" data-testid="mobile-buy-bar-qty-minus" onClick={() => onQty(Math.max(step, quantity - step))} className="p-2 active:bg-gray-100"><Minus size={14} /></button>
          <span className="w-7 text-center text-sm font-medium" data-testid="mobile-buy-bar-qty">{quantity}</span>
          <button type="button" data-testid="mobile-buy-bar-qty-plus" onClick={() => onQty(Math.min(maxQty, quantity + step))} className="p-2 active:bg-gray-100"><Plus size={14} /></button>
        </div>
        <Button data-testid="mobile-buy-bar-add" onClick={onAdd} disabled={disabled || adding} className="bg-orange-500 hover:bg-orange-600 h-11 px-4 shrink-0">
          {adding ? <Loader2 size={16} className="animate-spin" /> : added ? <CheckCircle2 size={16} /> : <ShoppingCart size={16} />}
          <span className="ml-1.5 text-sm">{added ? t('product.added') : t('common.addToCart')}</span>
        </Button>
      </div>
    </div>
  );
};

export default MobileBuyBar;
